import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  @Input() origin: string = "";
  @Input() title: string = "";
  @Input() routerLink: string = "";

  @Input() showAddButton: boolean = false;
  @Output() buttonClicked = new EventEmitter<boolean>();

  constructor(private router: Router) { }

  onButtonClick() {
    this.buttonClicked.emit(true);
  }

  returnOrigin() {
    this.router.navigate([this.routerLink]);
  }
}
